var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup44(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    width: 117.575,
    height: 169.447,
    viewBox: "0 0 117.575 169.447",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_44",
    "data-name": "Group 44",
    transform: "translate(572.294 -1818.326)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_139",
    "data-name": "Path 139",
    d: "M495.594,870.625h28.769a11.757,11.757,0,0,0,5.12-1.168,11.888,11.888,0,0,0,4.986-4.591,11.587,11.587,0,0,0,1.657-6V830.08a11.756,11.756,0,0,0-11.763-11.749H495.594a11.756,11.756,0,0,0-11.763,11.749v28.782a11.768,11.768,0,0,0,11.763,11.763",
    transform: "translate(-1056.125 999.996)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140",
    "data-name": "Path 140",
    d: "M589.643,818.33H560.861a11.744,11.744,0,0,0-11.749,11.749v28.783a11.734,11.734,0,0,0,8,11.138,11.377,11.377,0,0,0,3.749.624h28.782a11.767,11.767,0,0,0,11.763-11.762V830.079a11.756,11.756,0,0,0-11.763-11.749",
    transform: "translate(-1056.125 999.996)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_141",
    "data-name": "Path 141",
    d: "M526.3,881.518a11.432,11.432,0,0,0-1.943-.163H495.594a11.768,11.768,0,0,0-11.763,11.763V921.9a11.756,11.756,0,0,0,11.763,11.749h20.918a18.485,18.485,0,0,1,9.793-12.414Z",
    transform: "translate(-1056.125 999.996)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_142",
    "data-name": "Path 142",
    d: "M581.778,920.854H551.76V879.277a8.652,8.652,0,1,0-17.3,0V927.4a10.67,10.67,0,0,0-2.88.475,10.432,10.432,0,0,0-6.9,13.135l5.922,19.044,3.858,12.4v1.9a13.182,13.182,0,0,0,.666,4.157,13.393,13.393,0,0,0,12.74,9.263h29.272a13.423,13.423,0,0,0,13.42-13.42l.978-8.557,2.73-23.458.937-8.081a12.9,12.9,0,0,0-.136-1.929,13.423,13.423,0,0,0-13.284-11.478",
    transform: "translate(-1056.125 999.996)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143",
    "data-name": "Path 143",
    d: "M589.643,881.355H560.861c-.326,0-.639.014-.951.041V912.7h21.868a21.607,21.607,0,0,1,19.3,11.954,11.545,11.545,0,0,0,.326-2.758V893.118a11.768,11.768,0,0,0-11.763-11.763",
    transform: "translate(-1056.125 999.996)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup44);
export default __webpack_public_path__ + "static/media/Group 44.76493debc113351f98e0a9e10e931f4a.svg";
export { ForwardRef as ReactComponent };